// eslint-disable-next-line import/no-cycle
import HiddenContent from './HiddenContent.component';

export default HiddenContent;
